<template>
  <div v-if="!returnThirdSection">
    <form @submit.prevent="onSubmit">
  <h4>13. Dijagnoza/e</h4>
  <InputText type="text" placeholder="Unesite Vašu dijagnozu" name="diagnosis" v-model="diagnosis"/>

  <h4>14. Poslovna sposobnost</h4>
  <div class="button-container">
  <div class="checkbox-label">
    <RadioButton
      name="businessAbility"
      value="Puna"
      inputId="businessAbility-puna"
      v-model="selectedAbility"
    />
    <label for="businessAbility-puna" class="label">Puna</label>
    <RadioButton
      name="businessAbility"
      value="Ograničena"
      inputId="businessAbility-ogranicena"
      v-model="selectedAbility"
    />
    <label for="businessAbility-ogranicena" class="label">Ograničena</label>

    <RadioButton
      name="businessAbility"
      value="Oduzeta"
      inputId="businessAbility-oduzeta"
      v-model="selectedAbility"
    />
    <label for="businessAbility-oduzeta" class="label">Oduzeta</label>
  </div>
  </div>
  <div v-if="selectedAbility === 'Oduzeta' || selectedAbility === 'Ograničena'">
    <InputText type="text"  placeholder="Ime i prezime staraoca/teljke" class="inline-input" name="nameOfGuardianPerson" v-model="nameOfGuardianPerson" />
    <InputText type="text"  placeholder="JMBG staraoca/teljke" class="inline-input" name="identificationNumberofGuardianPerson" v-model="identificationNumberofGuardianPerson"/>
    <InputText type="text"  placeholder="Ulica i broj" class="inline-input" name="addressofGuardianPerson" v-model="addressofGuardianPerson"/>

    <LocationSelect
      v-model:city="cityOfGuardianPerson"
      :showCountry="false"
      cityPlaceholder="Grad"
    />
    <InputText type="text" placeholder="Broj lične karte i/ili pasoša" class="inline-input" name="numberOfDocumentofGuardianPerson" v-model="numberOfDocumentofGuardianPerson"/>
    <InputText type="text" placeholder="Naziv organa koji je izdao ličnu kartu/pasoš" class="inline-input" name="authorityOfTheDocumentofGuardianPerson" v-model="authorityOfTheDocumentofGuardianPerson"/>
    <Calendar
    v-model="guardianExpirationDate"
    showIcon
    :dateFormat="dateFormat"
    placeholder="Rok važenja lične karte/pasoša"
    class="calendar"
    name="expirationDateOfTheDocumentofGuardianPerson"
    :manualInput="false"
    showButtonBar
    :yearNavigator="true"
    yearRange="1930:2040"
  />

  </div>

  <h4>15. U kojim oblastima imate ograničenja funkcionisanja? Možete izabrati više odgovora.</h4>
  <div class="relative">
  <MultiSelect
    v-model="selectedField"
    :options="fields"
    optionLabel="period"
    placeholder="Izaberite"
    :maxSelectedLabels="20"
    class="w-full md:w-20rem"
    name="limitedFunctionality"
    appendTo="body"
  />
</div>

<div v-for="selected in selectedField || []" :key="selected.period">
  <h4>
    15.1 Sa kojim ograničenjima/barijerama se suočavate u oblasti
    {{ selected.period }}?
  </h4>
  <Textarea v-model="limitedTexts[selected.period]" autoResize rows="3" cols="47" name="restrictionsInTheArea"/>
</div>
<h4>16. Da li koristite pomagala, asistivnu tehnologiju i/ili pomoć životinja?</h4>
<div class="button-container">
<div class="checkbox-label">
    <RadioButton
      name="currentAidsYesNo"
      value="Da"
      inputId="currentAidsYesNo-da"
      v-model="selectAnswer1"
    />
    <label for="currentAidsYesNo-da" class="label">Da</label>

    <RadioButton
      name="currentAidsYesNo"
      value="Ne"
      inputId="currentAidsYesNo-ne"
      v-model="selectAnswer1"
    />
    <label for="currentAidsYesNo-ne" class="label">Ne</label>
  </div>
  </div>
  <div v-if="selectAnswer1 ==='Da'">
  <h4>16.1 Koje Vam je pomagalo, asistivna tehnologija i/ili pomoć životinje potrebna, a nemate je ili je lošeg kvaliteta? <br>Možete izabrati više odgovora.</h4>
  <div class="relative">
  <MultiSelect
    v-model="selectedField2"
    :options="fields2"
    optionLabel="period"
    placeholder="Izaberite"
    :maxSelectedLabels="20"
    class="w-full md:w-20rem"
    appendTo="body"
  />
</div>
</div>

  <h4>18. Da li imate potrebu za asistencijom (podrška i pomoć druge osobe)?</h4>
  <div class="button-container">
  <div class="checkbox-label">
    <RadioButton
      name="supportOfOtherPerson"
      value="Da"
      inputId="supportOfOtherPerson-da"
      v-model="selectAnswer2"
    />
    <label for="supportOfOtherPerson-da" class="label">Da</label>

    <RadioButton
      name="supportOfOtherPerson"
      value="Ne"
      inputId="supportOfOtherPerson-ne"
      v-model="selectAnswer2"
    />
    <label for="supportOfOtherPerson-ne" class="label">Ne</label>
  </div>
  </div>
  <div v-if="selectAnswer2 === 'Da'">
    <h4>18.1 Za koje aktivnosti Vam je potrebna asistencija?</h4>
    <!-- <InputText type="text" name="assistanceRequired"/> -->
    <Textarea autoResize rows="3" cols="47" name="assistanceRequired" v-model="assistanceRequired" />
  </div>

  <h4>19. Stambene prilike <br> Možete izabrati više odgovora.</h4>
    <div class="relative">
  <MultiSelect
    v-model="housingOpportunities"
    :options="opportunities"
    optionLabel="period"
    placeholder="Izaberite"
    :maxSelectedLabels="20"
    class="w-full md:w-20rem"
    appendTo="body"
  />
</div>

    <h4>20. Da li pripadate još nekoj marginalizovanoj grupi?</h4>
    <div class="button-container">
    <div class="checkbox-label">
    <RadioButton
      name="belongingToMarginalizedGroupsYesNo"
      value="Da"
      inputId="marginalizedGroups-da"
      v-model="selectAnswer3"
    />
    <label for="marginalizedGroups-da" class="label">Da</label>

    <RadioButton
      name="belongingToMarginalizedGroupsYesNo"
      value="Ne"
      inputId="marginalizedGroups-ne"
      v-model="selectAnswer3"
    />
    <label for="marginalizedGroups-ne" class="label">Ne</label>
  </div>
  </div>
  <div v-if="selectAnswer3 === 'Da'">
    <h4>20.1 Navesti kojoj/im marginalizovanoj/im grupi/ama pripadate</h4>
    <InputText type="text" name="belongingToMarginalizedGroups" v-model="belongingToMarginalizedGroups"/>
  </div>

  <h4>21. Da li želite da koristite neke od sadašnjih ili budućih usluga, koje I MI Boke pruža osobama s invaliditetom i njihovim porodicama? Neke od usluga su: besplatna pravna pomoć, besplatan pristupačan prevoz za OSI iz Boke, personalna asistencija, pomoć u kući, SOS telefon za žene i djevojke s invaliditetom s iskustvom nasilja i diskriminacije, i dr.</h4>
  <div class="button-container">
  <div class="checkbox-label">
    <RadioButton
      name="servicesOfMiBoka"
      value="Da"
      inputId="servicesOfMiBoka-da"
      v-model="selectAnswer4"
    />
    <label for="servicesOfMiBoka-da" class="label">Da</label>

    <RadioButton
      name="servicesOfMiBoka"
      value="Ne"
      inputId="servicesOfMiBoka-ne"
      v-model="selectAnswer4"
    />
    <label for="servicesOfMiBoka-ne" class="label">Ne</label>

    <RadioButton
      name="servicesOfMiBoka"
      value="Ne znam"
      inputId="servicesOfMiBoka-neznam"
      v-model="selectAnswer4"
    />
    <label for="servicesOfMiBoka-neznam" class="label">Ne znam</label>
  </div>
  </div>
  <div v-if="selectAnswer4 === 'Ne znam'">
    <h4>Razumijemo da sada niste sigurni da li Vam je potrebna neka od usluga I MI Boke. Kada Vam bude bila potrebna neka od naših usluga, kontaktirajte nas na broj mobilnog telefona: +382 68 022 805 (Viber, WhatsApp i Signal) i/ili na e-mail: podrska@imiboke.me.</h4>
  </div>
  <div v-if="selectAnswer4 === 'Da'">
    <InputText type="text" placeholder="JMBG" class="inline-input" name="identificationNumber" v-model="identificationNumber" />
    <InputText type="text" placeholder="Broj lične karte i/ili pasoša" class="inline-input" name="numberOfDocument" v-model="numberOfDocument"/>
    <InputText type="text" placeholder="Naziv organa koji je izdao ličnu kartu/pasoš" name="authorityOfTheDocument" v-model="authorityOfTheDocument" style="margin-bottom: 8px"/>
    <!-- <InputText type="text" placeholder="Rok važenja lične karte/pasoša" name="expirationDateOfTheDocument" /> -->
    <Calendar
      v-model="docExpirationDate"
      showIcon
      name="expirationDateOfTheDocument"
      :dateFormat="dateFormat"
      placeholder="dd/mm/yyyy"
      class="calendar"
      :manualInput="false"
      showButtonBar
      :yearNavigator="true"
      yearRange="1930:2040"
    />
  </div>
 <div class="button-container">
  <Button @click="goBack" class="sendAnswers" type="button" outlined style="margin-right: 5px;">Nazad</Button>
  <Button type="submit" class="sendAnswers">Nastavi</Button>
 </div>
</form>
</div>
<ThirdSection v-if="returnThirdSection"/>

</template>

<script setup>
import ThirdSection from "./ThirdSection.vue";
import LocationSelect from "./LocationSelect.vue";
import { inject, ref, reactive, nextTick, provide } from "vue";

const objekat = inject("objekat");
const pageContainer = inject("pageContainer");

const returnSecondSection = inject("returnSecondSection");

const scrollToTop = () => {
  nextTick(() => {
    if (pageContainer.value) {
      // Ako roditeljski element ima overflow (npr. overflow-y: auto)
      pageContainer.value.scrollTop = 0;
    } else {
      // Rezervna opcija: skrolovanje celog prozora
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  });
};

const returnThirdSection = ref(false);
provide("returnThirdSection", returnThirdSection);

const fields = [
  { period: "Obrazovanje i vaspitanje" },
  { period: "Rad i zapošljavanje" },
  { period: "Zdravstvena zaštita" },
  { period: "Rehabilitacija i habilitacija" },
  { period: "Učešće u postupcima pred organima (pristup pravdi)" },
  { period: "Informisanje" },
  { period: "Fizičko okruženje (javne zgrade i površine)" },
  { period: "Javni prevoz" },

  {
    period:
      "Samostalan život i uključenost u zajednicu (uključujući i stavove)",
  },
  { period: "Porodični život" },
  { period: "Privatnost" },
  { period: "Sloboda od torture i nasilja" },
  { period: "Adekvatan životni standard" },
  { period: "Kultura" },
  { period: "Sport i rekreacija" },
  { period: "Slobodno vrijeme (zabava i igra)" },
  { period: "Politički i javni život" },
];

const fields2 = [
  { period: "Ne trebaju mi pomagala, asistivna tehnologija i/ili pomoć životinja" },
  { period: "Slušni aparat" },
  { period: "Invalidska kolica" },
  { period: "Hodalica" },
  { period: "Štake" },
  { period: "Štap" },
  { period: "Bijeli štap" },
  { period: "Pas vodič" },
  { period: "Pas pomagač" },
  { period: "Terapeutski pas" },
  { period: "Proteza (vještačka ruka/noga)" },
  { period: "Skuter" },
  { period: "Elektromotorni krevet" },
  { period: "Hidraulična dizalica (transferi/prebacivanje)" },
  { period: "Govorni program (čitanje teksta na računaru i mobilnom telefonu)" },
  { period: "Program za pretvaranje govora u tekst" },
  { period: "Pomagala za komunikaciju osoba s autizmom, cerebralnom paralizom i dr. koje ne govore" },
];

const opportunities = [
  { period: "Podstanar/ka" },
  { period: "Vlasnik/ca" },
  { period: "Zajedničko domaćinstvo" },
  { period: "Uslovan" },
  { period: "Neuslovan za stanovanje" },
];

const dateFormat = "dd/mm/yy";

// Parsira string "dd/mm/yyyy" u JS Date
function parseDateFull(str) {
  if (!str) return null;
  const [day, month, year] = str.split("/");
  const dd = parseInt(day, 10);
  const mm = parseInt(month, 10) - 1;
  const yyyy = parseInt(year, 10);
  if (isNaN(dd) || isNaN(mm) || isNaN(yyyy)) return null;
  return new Date(yyyy, mm, dd);
}

// Formatira JS Date u "dd/mm/yyyy"
function formatDateFull(datum) {
  if (!datum) return "";
  const d = new Date(datum);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

// Vraća izbor iz MultiSelect-a mapiran na objekte iz liste opcija (poređenje po "period"),
// da bi prethodno sačuvane vrijednosti bile prikazane kao izabrane.
function restoreSelection(options, saved) {
  if (!Array.isArray(saved)) return saved ?? null;
  return saved
    .map((item) => {
      const period = item && typeof item === "object" ? item.period : item;
      return options.find((o) => o.period === period) || (period ? { period } : null);
    })
    .filter(Boolean);
}

const clean = (v) => (typeof v === "string" ? v.trim() : v);

// ---- Stanje forme (inicijalizovano iz objekta, da se ništa ne izgubi pri povratku nazad) ----
const gp = objekat.guardianPerson;

const diagnosis = ref(objekat.diagnosis || "");
const selectedAbility = ref(objekat.businessAbility);

const nameOfGuardianPerson = ref(gp.nameOfGuardianPerson || "");
const identificationNumberofGuardianPerson = ref(gp.identificationNumberofGuardianPerson || "");
const addressofGuardianPerson = ref(gp.addressofGuardianPerson || "");
const cityOfGuardianPerson = ref(gp.cityOfGuardianPerson || "");
const numberOfDocumentofGuardianPerson = ref(gp.numberOfDocumentofGuardianPerson || "");
const authorityOfTheDocumentofGuardianPerson = ref(gp.authorityOfTheDocumentofGuardianPerson || "");
const guardianExpirationDate = ref(parseDateFull(gp.expirationDateOfTheDocumentofGuardianPerson));

// 15: izabrane oblasti + tekst barijera po oblasti (ključ = period)
const selectedField = ref(restoreSelection(fields, objekat.limitedFunctionality));
const limitedTexts = reactive({});
(Array.isArray(objekat.limitedFunctionality) ? objekat.limitedFunctionality : []).forEach((item) => {
  if (item && typeof item === "object" && typeof item.period === "string") {
    limitedTexts[item.period] = typeof item.value === "string" ? item.value : "";
  }
});

const selectAnswer1 = ref(objekat.currentAidsYesNo);
const selectedField2 = ref(restoreSelection(fields2, objekat.neededAids));
const selectAnswer2 = ref(objekat.supportOfOtherPerson);
const assistanceRequired = ref(objekat.assistanceRequired || "");
const housingOpportunities = ref(restoreSelection(opportunities, objekat.housingConditions));
const selectAnswer3 = ref(objekat.belongingToMarginalizedGroupsYesNo);
const belongingToMarginalizedGroups = ref(objekat.belongingToMarginalizedGroups || "");
const selectAnswer4 = ref(objekat.servicesOfMiBoka);
const identificationNumber = ref(objekat.identificationNumber || "");
const numberOfDocument = ref(objekat.numberOfDocument || "");
const authorityOfTheDocument = ref(objekat.authorityOfTheDocument || "");
const docExpirationDate = ref(parseDateFull(objekat.expirationDateOfTheDocument));

// Upisuje stanje sekcije u objekat. Polja koja su sakrivena (uslovna pitanja) se ne šalju.
const saveToObjekat = () => {
  const hasGuardian =
    selectedAbility.value === "Oduzeta" || selectedAbility.value === "Ograničena";
  const needsAssistance = selectAnswer2.value === "Da";
  const isMarginalized = selectAnswer3.value === "Da";
  const wantsServices = selectAnswer4.value === "Da";

  objekat.diagnosis = clean(diagnosis.value);
  objekat.businessAbility = selectedAbility.value;

  objekat.guardianPerson.nameOfGuardianPerson = hasGuardian ? clean(nameOfGuardianPerson.value) : null;
  objekat.guardianPerson.identificationNumberofGuardianPerson = hasGuardian ? clean(identificationNumberofGuardianPerson.value) : null;
  objekat.guardianPerson.addressofGuardianPerson = hasGuardian ? clean(addressofGuardianPerson.value) : null;
  objekat.guardianPerson.cityOfGuardianPerson = hasGuardian ? clean(cityOfGuardianPerson.value) : null;
  objekat.guardianPerson.numberOfDocumentofGuardianPerson = hasGuardian ? clean(numberOfDocumentofGuardianPerson.value) : null;
  objekat.guardianPerson.authorityOfTheDocumentofGuardianPerson = hasGuardian ? clean(authorityOfTheDocumentofGuardianPerson.value) : null;
  objekat.guardianPerson.expirationDateOfTheDocumentofGuardianPerson =
    hasGuardian && guardianExpirationDate.value ? formatDateFull(guardianExpirationDate.value) : null;

  // [{ period, value }] — value je opis barijera za tu oblast
  objekat.limitedFunctionality = Array.isArray(selectedField.value)
    ? selectedField.value.map((item) => ({
        period: item.period,
        value: clean(limitedTexts[item.period]) || null,
      }))
    : selectedField.value;

  objekat.currentAidsYesNo = selectAnswer1.value;
  objekat.neededAids = selectedField2.value;
  objekat.supportOfOtherPerson = selectAnswer2.value;
  objekat.assistanceRequired = needsAssistance ? clean(assistanceRequired.value) : null;
  objekat.housingConditions = housingOpportunities.value;
  objekat.belongingToMarginalizedGroupsYesNo = selectAnswer3.value;
  objekat.belongingToMarginalizedGroups = isMarginalized ? clean(belongingToMarginalizedGroups.value) : null;
  objekat.servicesOfMiBoka = selectAnswer4.value;
  objekat.identificationNumber = wantsServices ? clean(identificationNumber.value) : null;
  objekat.numberOfDocument = wantsServices ? clean(numberOfDocument.value) : null;
  objekat.authorityOfTheDocument = wantsServices ? clean(authorityOfTheDocument.value) : null;
  objekat.expirationDateOfTheDocument =
    wantsServices && docExpirationDate.value ? formatDateFull(docExpirationDate.value) : null;
};

const goBack = () => {
  // Sačuvaj unos i na povratku, da ne nestane kad se korisnik vrati naprijed
  saveToObjekat();
  returnSecondSection.value = false; // Sakrivaš drugu sekciju -> prikazuje se prva
  scrollToTop();
};

const onSubmit = () => {
  saveToObjekat();
  returnThirdSection.value = true;
  scrollToTop();
};
</script>
